export const detectFinancialYearIntent = (text: string) => {
    const cleaned = text.toLowerCase().trim();

    /** ----------------------------------
     * DELETE: No name
     * ---------------------------------- */
    if (cleaned === "delete financial year" || cleaned === "remove financial year") {
        return { intent: "delete_financial_year" };
    }

    /** ----------------------------------
     * DELETE: With name
     * ---------------------------------- */
    const deleteMatch = cleaned.match(/delete (.+) financial year/);
    if (deleteMatch) {
        return { intent: "delete_financial_year", name: deleteMatch[1].trim() };
    }

    /** ----------------------------------
     * CREATE: Without name
     * ---------------------------------- */
    if (cleaned.includes("create financial year") || cleaned.includes("add financial year")) {
        return { intent: "create_financial_year" };
    }

    /** ----------------------------------
     * CREATE: With name
     * ---------------------------------- */
    const createMatch = cleaned.match(/create financial year named (.+)/);
    if (createMatch) {
        return { intent: "create_financial_year", name: createMatch[1].trim() };
    }

    return null;
};
